module.exports = __webpack_public_path__ + "static/preview2-6b07ea0ed9deaea20e033fab212398f2.jpg";